import { Component, Vue } from 'vue-property-decorator'
import LinkItem from '~/types/LinkItem'
import SectionHelper from '~/utils/sectionHelper'
import PageHeader from '~/components/page/PageHeader'
import HeaderType from '~/types/enum/HeaderType'
import ProductImage from '~/components/page/product/ProductImage'
import ProductInfo from '~/components/page/product/ProductInfo'
import ProductInstruction from '~/components/page/product/ProductInstruction'
import ProductReviews from '~/components/page/product/ProductReviews'
import ProductCertificates from '~/components/page/product/ProductCertificates'
import ProductMenu from '~/components/page/product/ProductMenu'
import ProductMenuItem from '~/types/ProductMenuItem'
import loc from '~/utils/loc'
import s from '~/utils/s'
import ProductListSmall from '~/components/block/ProductListSmall'
import { SfSection } from '~/types/api/SfSection'
import { SlideOptions } from '~/types/Slider'
import mainBreadcrumbsSubmenuItems from '~/utils/mainBreadcrumbsSubmenuItems'
import catalogSubmenuItems from '~/utils/catalogSubmenuItems'
import ProductSlides from '~/components/block/ProductSlides'
import Img from '~/types/api/Img'
import ProductDeliveryInfo from '~/components/page/product/ProductDeliveryInfo'
import { MetaInfo } from 'vue-meta'

@Component({
  components: {
    ProductImage
  },
  head () {
    return {
      link: [
        {
          rel: 'canonical',
          href: s(this.$store).productPage.relCanonicalUrl
        }
      ]
    } as MetaInfo
  }
})
export default class ProductPage extends Vue {
  isShowFixedInfo: boolean = false;

  breadcrumb: LinkItem[] = []

  sliderOptions: SlideOptions = {
    slidesToShow: 1,
    infinite: true,
    navButtons: false,
    dots: false
  }

  loadBreadcrumbs () {
    const helper = new SectionHelper(s(this.$store).general.sections, this.$store)
    const sections = s(this.$store).productPage.sectionId
    const categoryId = s(this.$store).categoryPage.category.id.toString()
    const paths = helper.getSectionsPath((categoryId === '0' || !categoryId) ? sections[0] : categoryId)
    s(this.$store).categoryPage.setPathSections(paths)
    const breadcrumb = s(this.$store).categoryPage.pathSections.map((e: SfSection) => ({
      title: e.name,
      location: helper.getSectionPathById(e.id) ?? 'catalog',
      submenuItems: catalogSubmenuItems(this.$store, e.name)
    }))
    const list = [
      {
        title: 'Главная',
        location: loc(this.$store, { name: 'index' }),
        submenuItems: mainBreadcrumbsSubmenuItems(this.$store)
      },
      ...breadcrumb
    ]

    list.push({
      title: s(this.$store).productPage.title,
      location: helper.getProductLink((categoryId === '0' || !categoryId) ? sections[0] : categoryId, s(this.$store).productPage.code),
      submenuItems: []
    })
    // s(this.$store).seo.setCanonical(String(list[list.length - 1].location))
    this.breadcrumb = list
  }

  get isCertificates () {
    return s(this.$store).productPage.certificates && s(this.$store).productPage.certificates.length > 0
  }

  get isRecommended () {
    return s(this.$store).productPage.recommended && s(this.$store).productPage.recommended.length > 0
  }

  get isAnalogs () {
    return s(this.$store).productPage.analogs && s(this.$store).productPage.analogs.length > 0
  }

  get deliveryPrice () {
    return s(this.$store).productPage.deliveryPrice
  }

  get freeDeliveryFrom () {
    return s(this.$store).productPage.freeDeliveryFrom
  }

  get productMenu (): ProductMenuItem[] {
    const { canReview } = s(this.$store).productPage

    const items = [
      {
        code: 'instruction',
        name: 'Инструкция по применению',
        selector: '.product-page__col-instruction'
      }
    ]

    if (canReview) {
      items.push({
        code: 'reviews',
        name: 'Отзывы',
        selector: '.product-page__col-reviews'
      })
    }

    if (this.isCertificates) {
      items.push({
        code: 'certificates',
        name: 'Сертификаты',
        selector: '.product-page__col-certificates'
      })
    }

    return items
  }

  get defaultImg (): Img {
    return {
      d: require('~/assets/image/pill.png'),
      t: require('~/assets/image/pill.png'),
      m: require('~/assets/image/pill.png'),
      default: true
    }
  }

  async mounted () {
    this.loadBreadcrumbs()
    const regionId = s(this.$store).regions.regionId ?? 0
    const sectionId = s(this.$store).regions.sectionId
    const productCode = s(this.$store).productPage.id
    await Promise.all([s(this.$store).productPage.loadRecommended({
      regionId,
      sectionId,
      code: productCode
    }),
    await s(this.$store).productPage.loadAnalogs({ regionId, sectionId, code: productCode }),
    s(this.$store).productPage.loadReviewsForProduct(productCode, regionId),
    s(this.$store).productPage.loadViewedProducts()])
    // window.addEventListener('scroll', this.fixedInfoHandler)
    // window.addEventListener('resize', this.fixedInfoHandler)
    // this.fixedInfoHandler()
  }

  beforeDestroy () {
    s(this.$store).productPage.clearAnalogsAndRecommended()
    s(this.$store).categoryPage.setDefaultCategory()
    window.removeEventListener('scroll', this.fixedInfoHandler)
    window.removeEventListener('resize', this.fixedInfoHandler)
    s(this.$store).categoryPage.clearIsPreset()
  }

  fixedInfoHandler () {
    this.isShowFixedInfo = window.scrollY > 500
  }

  renderRecommended () {
    if (this.isRecommended) {
      return (
        <div class="product-page__col-recommended">
          <div class="product-page__recommended-products-container">
            <div class="product-page__recommended-products-items">
              <ProductSlides {...{
                props: {
                  products: s(this.$store).productPage.recommended,
                  title: 'С этим товаром покупают',
                  isShowButton: false
                }
              }} />
            </div>
          </div>
        </div>
      )
    }
  }

  renderAnalogs () {
    if (this.isAnalogs) {
      return (
        <div class="product-page__col-analogs">
          <div class="product-page__analogs-products-container">
            <div class="product-page__analogs-products-items">
              <ProductSlides {...{
                props: {
                  products: s(this.$store).productPage.analogs,
                  title: 'Другие формы выпуска',
                  isShowButton: false
                }
              }} />
            </div>
          </div>
        </div>
      )
    }
  }

  renderViewedProducts () {
    if (s(this.$store).productPage.viewedProducts.items.length > 0) {
      return (
        <div class="product-page__viewed-products">
          <div class="product-page__viewed-products-container">
            <div class="product-page__viewed-products-title">
              Недавно просмотренные товары
            </div>
            <div class="product-page__viewed-products-items">
              <ProductListSmall props={{ products: s(this.$store).productPage.viewedProducts.items }} />
            </div>
          </div>
        </div>
      )
    }
  }

  renderReviews () {
    const userReviews = s(this.$store).productPage.reviews.filter(review => review.userId === s(this.$store).auth.user?.id)
    return (
      <div class="product-page__col-reviews">
        <ProductReviews {...{
          props: {
            reviews: s(this.$store).productPage.reviews,
            userReview: userReviews[0]
          }
        }} />
      </div>
    )
  }

  renderDeliveryInfo () {
    return (
      <div class="product-page__col-delivery">
        <ProductDeliveryInfo {...{
          props: {
            byPrescription: s(this.$store).productPage.byPrescription,
            eCertificateFlag: s(this.$store).productPage.eCertificateFlag,
            hasPickup: s(this.$store).productPage.hasPickup,
            hasDelivery: s(this.$store).productPage.hasDelivery,
            deliveryPrice: s(this.$store).productPage.deliveryPrice,
            freeDeliveryFrom: s(this.$store).productPage.freeDeliveryFrom,
            paymentInfoPickup: s(this.$store).productPage.paymentInfoPickup,
            paymentInfoDelivery: s(this.$store).productPage.paymentInfoDelivery
          }
        }} />
      </div>
    )
  }

  render () {
    const { canReview } = s(this.$store).productPage

    // Выключен слайдер на изображение карточки задача RM7551
    // const images = s(this.$store).productPage.images.length !== 0 ? s(this.$store).productPage.images : [this.defaultImg]
    // const initialImage: number = images.findIndex(e => e.default === true)

    return (
      <div class="product-page">
        <transition name="product-page__fixed-slide-fade">
          {this.isShowFixedInfo &&
            <div class="product-page__fixed">
              {/* <ProductFixed /> */}
            </div>
          }
        </transition>
        <div class="product-page__header">
          <PageHeader {...{
            props: {
              typeHeader: HeaderType.Product,
              breadcrumb: this.breadcrumb
            }
          }} />
        </div>
        <div class="product-page__content" itemscope itemtype="https://schema.org/Product" data-id={s(this.$store).productPage.id}>
          <div class="product-page__container product-page__first-block">
            <div class="product-page__row">
              <div class="product-page__col-image">
                <product-image
                  {...{
                    props: {
                      img:
                        s(this.$store).productPage.img &&
                          Object.keys(s(this.$store).productPage.img as object)
                            .length !== 0
                          ? s(this.$store).productPage.img
                          : this.defaultImg,

                      title: s(this.$store).productPage.title,
                      alt: s(this.$store).productPage.title
                    },
                    key: s(this.$store).productPage.id
                  }}
                />

                {/* // Выключен слайдер на изображение карточки задача RM7551
                {!!images.length && <agile options={this.sliderOptions} initialSlide = {initialImage}>
                  {images.map(img => (<product-image {...{
                    props: {
                      img,
                      title: s(this.$store).seo.imgTitle,
                      alt: s(this.$store).seo.imgAlt
                    },
                    key: s(this.$store).productPage.id
                  }} />))
                  }
                </agile>} */}
                <div class="product-page-image__info">
                  Внешний вид товара может отличаться
                </div>
              </div>
              <div class="product-page__col-info">
                <ProductInfo {...{
                  props: {
                    isAnalogs: this.isAnalogs
                  }
                }} />
                {this.renderDeliveryInfo()}
                {
                  s(this.$store).productPage.seoName &&
                  <div class="product-page-info__title-wrapper">
                    <h1 class="product-page-info__title seoName" itemprop="name">
                      {s(this.$store).productPage.seoName}
                    </h1>
                  </div>
                }
              </div>
            </div>
          </div>
          {this.renderRecommended()}
          <div class="product-page__container">
            <div class="product-page__row">
              <div class={{
                'product-page__col-menu': true,
                'product-page__col-menu--seo-name': s(this.$store).productPage.seoName
              }}>
                <ProductMenu {...{
                  props: {
                    items: this.productMenu
                  }
                }} />
              </div>
              <div class="product-page__col-instruction">
                <ProductInstruction {...{
                  props: {
                    items: s(this.$store).productPage.textProps
                  }
                }} />
              </div>

              {canReview && this.renderReviews()}

              {this.isCertificates &&
                <div class="product-page__col-certificates">
                  <ProductCertificates {...{
                    props: {
                      items: s(this.$store).productPage.certificates
                    }
                  }} />
                </div>
              }
            </div>
          </div>
        </div>
        <div class="product-page__other-products">
          {this.renderViewedProducts()}
        </div>
      </div>
    )
  }
}
